import kamala from '../../kamala'
import RdTag from './RdTag'

RdTag.install = function (Vue) {
  kamala(Vue)
  Vue.component(RdTag.name, RdTag)
}

export {
  RdTag,
}

export default RdTag
